import { Link } from 'react-router-dom';
import { numberFormatter } from '../../utils/financials';
import { cediSign } from '../../utils/constants';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';

function loanPath(item) {
    if (!item.loanId || !item.loanState) return null;
    return `/${item.loanState}/${item.loanId}`;
}

function Recents({ recPayments }) {
    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm p-5 h-full">
            <div className="mb-4">
                <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">Recent Payments</p>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Latest disbursements and repayments</p>
            </div>

            <ul className="divide-y divide-gray-50 dark:divide-gray-700/50">
                {recPayments?.length > 0 ? (
                    recPayments.map((item, index) => {
                        const path = loanPath(item);
                        const inner = (
                            <div className="flex items-center justify-between py-3 gap-3 group">
                                <div className="flex flex-col min-w-0">
                                    <span className={`text-sm font-medium truncate ${path ? 'text-gray-800 dark:text-gray-100 group-hover:text-[#1e3a6e] dark:group-hover:text-blue-400 transition-colors' : 'text-gray-800 dark:text-gray-100'}`}>
                                        {item.name}
                                    </span>
                                    <span className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{item.date}</span>
                                </div>
                                <div className="shrink-0 flex items-center gap-2">
                                    <div className="flex flex-col items-end gap-1">
                                        <span className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-medium border ${
                                            item.type === 'repay'
                                                ? 'bg-emerald-50 text-emerald-600 border-emerald-100'
                                                : 'bg-blue-50 text-[#1e3a6e] border-blue-100'
                                        }`}>
                                            {item.type === 'repay' ? 'Repay' : 'Disburse'}
                                        </span>
                                        <span className={`text-sm font-semibold tabular-nums ${
                                            item.type === 'repay' ? 'text-emerald-600' : 'text-[#1e3a6e] dark:text-[#6396f3]'
                                        }`}>
                                            {cediSign}{numberFormatter(item.amount)}
                                        </span>
                                    </div>
                                    {path && (
                                        <HugeiconsIcon
                                            icon={ArrowRight01Icon}
                                            size={14}
                                            className="text-gray-300 group-hover:text-[#1e3a6e] transition-colors shrink-0"
                                        />
                                    )}
                                </div>
                            </div>
                        );

                        return (
                            <li key={index}>
                                {path ? (
                                    <Link to={path} className="block">{inner}</Link>
                                ) : (
                                    inner
                                )}
                            </li>
                        );
                    })
                ) : (
                    <li className="py-8 text-center text-sm text-gray-400">No recent payments</li>
                )}
            </ul>
        </div>
    );
}

export default Recents;
